module.exports = __webpack_public_path__ + "img/image-delete.9b5f6124.svg";